/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel
     */
    value?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

